import React from "react";
import {
    useGetApartmentOwnersQuery,
    useGetExpenseCategoriesQuery,
    useGetMunicipalitySectionsQuery,
    useGetOwnerGroupsQuery,
    useGetYearsInOperationQuery,
} from "@/store/booking-management-api";
import { useGetApartmentsQuery } from "@/store/slices/apartments";

export const DemoDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const apartments = useGetApartmentsQuery(false);
    const owners = useGetApartmentOwnersQuery(false);
    const categories = useGetExpenseCategoriesQuery(undefined);
    const years = useGetYearsInOperationQuery(false);
    const municipalitySections = useGetMunicipalitySectionsQuery(undefined);
    const ownerGroups = useGetOwnerGroupsQuery(undefined);

    const isError =
        apartments.isError || owners.isError || categories.isError || years.isError || municipalitySections.isError || ownerGroups.isError;

    const isPending =
        apartments.isLoading ||
        apartments.isUninitialized ||
        owners.isLoading ||
        owners.isUninitialized ||
        categories.isLoading ||
        categories.isUninitialized ||
        years.isLoading ||
        years.isUninitialized ||
        municipalitySections.isLoading ||
        municipalitySections.isUninitialized ||
        ownerGroups.isLoading ||
        ownerGroups.isUninitialized;

    if (isError) {
        console.error("Demo data loading error:", {
            apartments: apartments.error,
            owners: owners.error,
            categories: categories.error,
            years: years.error,
        });
    }

    if (isPending) {
        return <div>Loading...</div>;
    }

    return <>{children}</>;
};
